import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Talk to MISTR',
    desc: 'Voice, text, Slack, or email. Say what you need in plain language.'
  }, {
    num: '2',
    title: 'MR Understands',
    desc: 'Pulls context from your entire business. Knows the history, team, and goals.'
  }, {
    num: '3',
    title: 'Action Happens',
    desc: 'Tasks created. Emails sent. Campaigns managed. Follow-ups handled.'
  }, {
    num: '4',
    title: 'You Get Results',
    desc: 'Reports, updates, and confirmations. Always informed, never in the weeds.'
  }];
  return <section className="section-padding bg-section-gradient overflow-hidden relative" data-id="element-331" data-mp="gtbefhlmmpva">
      <div className="inner-container relative z-10" data-id="element-332" data-mp="14j5ue818sujr">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-333" data-mp="14hkzghb0n9ld">
          <span className="text-teal text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-334" data-mp="19ae4z7eb6lyi">
            How It Works
          </span>
          <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-white" data-id="element-335" data-mp="2rm7emqa975ab">
            Say It. Done.
          </h2>
        </div>

        <div className="relative max-w-6xl mx-auto" data-id="element-336" data-mp="31bzb5q1wy8hf">
          {/* Animated Connector Line */}
          <div className="hidden md:block absolute top-14 left-[10%] right-[10%] h-1 overflow-hidden rounded-full" data-id="element-337" data-mp="2wk8y3cbld6mb">
            <div className="h-full bg-gradient-to-r from-purple/20 via-teal/20 to-purple/20" data-id="element-338" data-mp="3ab4cf44v0fxa" />
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple/40 to-transparent" initial={{
            x: '-100%'
          }} animate={{
            x: '200%'
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-339" data-mp="36bc2oo3qc3qc" />
          </div>

          <div className="grid md:grid-cols-4 gap-12 relative z-10" data-id="element-340" data-mp="1kz29j82pznk4">
            {steps.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-341" data-mp="3l1tmscaqj4kh" data-mpi={i}>
                {/* Gradient Circle */}
                <div className="relative w-28 h-28 mb-6" data-id="element-342" data-mp="hii7wogftbbj">
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-purple to-teal p-[3px] shadow-[0_0_20px_rgba(124,58,237,0.2)] group-hover:shadow-[0_0_30px_rgba(124,58,237,0.4)] transition-shadow" data-id="element-343" data-mp="hl4g8qb5juut">
                    <div className="w-full h-full rounded-full bg-dark-bg flex items-center justify-center" data-id="element-344" data-mp="vi9pez65x9ua">
                      <span className="text-4xl font-poppins font-bold bg-gradient-to-br from-purple to-teal bg-clip-text text-transparent" data-id="element-345" data-mp="15mzp0ye3g1vc">
                        {step.num}
                      </span>
                    </div>
                  </div>
                </div>
                <h3 className="font-poppins font-bold text-lg mb-3 text-white" data-id="element-346" data-mp="rmovtopbab70">
                  {step.title}
                </h3>
                <p className="text-steel text-sm leading-relaxed" data-id="element-347" data-mp="1od7lwyr79w33">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}